import SVGInjector from 'svg-injector';

// Elements to inject
const mySVGsToInject = document.querySelectorAll('[data-svg-inject]');

// Do the injection
SVGInjector(mySVGsToInject);
